import React from "react";

/* Trust bar — easy to update as real credentials are earned.
   To swap an item later: change the `label` (and optionally `icon`). */
const TRUST_ITEMS = [
  {
    label: "Veteran-Owned Business",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l2.39 4.84L20 7.66l-3.83 3.74.9 5.27L12 14.2l-5.07 2.47.9-5.27L4 7.66l5.61-.82L12 2z"/>
        <path d="M12 14.2v6.8"/>
        <path d="M9 22h6"/>
      </svg>
    ),
  },
  {
    label: "Serving Businesses Nationwide",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/>
        <path d="M3 12h18"/>
        <path d="M12 3a13 13 0 010 18M12 3a13 13 0 000 18"/>
      </svg>
    ),
  },
  {
    label: "AI Solutions for Growing Businesses",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l1.8 4.8L18.6 9.6 14.4 12l2.4 4.8L12 15l-4.8 1.8L9.6 12 5.4 9.6l4.8-1.8L12 3z"/>
      </svg>
    ),
  },
  {
    label: "Denver, Colorado Studio",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s-7-7.2-7-13a7 7 0 0114 0c0 5.8-7 13-7 13z"/>
        <circle cx="12" cy="9" r="2.5"/>
      </svg>
    ),
  },
  {
    label: "50+ Businesses Trusted",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="9" r="3.2"/>
        <circle cx="17" cy="10" r="2.6"/>
        <path d="M3 20c0-3 2.7-5 6-5s6 2 6 5"/>
        <path d="M14 20c.2-2.4 2-4 4-4s3.8 1.6 4 4"/>
      </svg>
    ),
  },
  {
    label: "100% Custom-Built Systems",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l8 5v8l-8 5-8-5V8z"/>
        <path d="M4 8l8 5 8-5"/>
        <path d="M12 13v8"/>
      </svg>
    ),
  },
];

export default function TrustBar() {
  return (
    <section className="relative border-t border-b border-brand py-10 md:py-12 bg-base" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-8 gap-y-8">
          {TRUST_ITEMS.map((item, i) => (
            <div key={item.label} className="flex flex-col items-center text-center md:items-start md:text-left gap-3 fade-up" style={{ animationDelay: `${i * 70}ms` }} data-testid={`trust-item-${i}`}>
              <div className="w-7 h-7 text-brand opacity-90">{item.icon}</div>
              <div className="font-display text-sm md:text-[15px] tracking-wide text-primary leading-snug">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
